// src/services/api.js
import axios from 'axios';
import { createClient } from '@supabase/supabase-js';

// Bu satırı yeni sunucunuzun URL'siyle değiştirin
const API_BASE_URL = 'https://api.librozi.com'; 
const api = axios.create({
  baseURL: `${API_BASE_URL}/api`,
  timeout: 10000,
});
export default api;
